/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Blob_Save_Dialog_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No writable destinations found." |
*
* @param {Chat_Blob_Save_Dialog_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_save_dialog_no_results = /** @type {((inputs?: Chat_Blob_Save_Dialog_No_ResultsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_Save_Dialog_No_ResultsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine beschreibbaren Ziele gefunden.")
	return /** @type {LocalizedString} */ ("No writable destinations found.")
});